<template>
    <modal name="video-image-modal" transition="scale" @before-open="beforeOpen" :width="window.width">
        <div slot="top-right" class="ct-top-right" @click="$modal.hide('video-image-modal')" >
            <font-awesome-icon icon="times"/>
        </div>
        <video v-if="videoURI" :src="videoURI" controls></video>
        <div v-if="imageURI" class="image" :style="`background-image: url(${imageURI})`"></div>
    </modal>
</template>

<script>
export default {
    name: 'VideoImageModal',
    data() {
        return {
            videoURI: "",
            imageURI: "",
            window: {
                width: 0
            }
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        beforeOpen (event) {
            this.videoURI = event.params.videoURI;
            this.imageURI = event.params.imageURI;
        },
        handleResize() {
            this.window.width = window.innerWidth > 600 ? (window.innerWidth-window.innerWidth*.5) : window.innerWidth-100;
        }
    }
}
</script>

<style scoped>
    video, .image {
        width: 100%;
        height: 100%;
    }
    .image {
        background-repeat: no-repeat;
        background-size: contain;
        background-color: rgba(0, 0, 0, 1);
        background-position: center center;
    }
    .ct-top-right {
        cursor: pointer;
        padding-top: 20px;
        padding-right: 30px;
        font-weight: 600;
        color: white;
        text-shadow: 0 0px 20px black;
    }
    .scale-enter-active,
    .scale-leave-active {
        transition: all 0.5s;
    }
    .scale-enter,
    .scale-leave-active {
        opacity: 0;
        transform: scale(0.3) translateY(24px);
    }
</style>